import React from 'react';
import PropTypes from 'prop-types';
import { withFormik, Field } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';
import { Form, Row, Col, Button } from 'reactstrap';

import { renderField } from 'core/utils/formik';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

const EmployeeExposureForm = ({ handleSubmit, isSubmitting, isValid }) => (
  <Form
    onSubmit={handleSubmit}
    className="EmployeeExposureForm"
  >
    <Row>
      <Col md="4">
        <Field
          type="date"
          dateFormat="m/d/Y"
          name="start_date"
          label="Start Date"
          component={renderField}
        />
      </Col>

      <Col md="4">
        <Field
          type="date"
          dateFormat="m/d/Y"
          name="end_date"
          label="End Date"
          component={renderField}
        />
      </Col>

      <Col className="align-self-end" md="4">
        <Button
          type="submit"
          color="primary"
          disabled={!isValid || isSubmitting}
        >
          Generate
        </Button>
      </Col>
    </Row>
  </Form>
);

EmployeeExposureForm.propTypes = propTypes;

export default withFormik({
  isInitialValid: true,
  mapPropsToValues: () => ({
    start_date: moment().subtract(1, 'month').toDate(),
    end_date: new Date(),
  }),
  validationSchema: Yup.object().shape({
    start_date: Yup.string().required('Required'),
    end_date: Yup.string().required('Required'),
  }),
  handleSubmit: (values, formikBag) => {
    const { setSubmitting, props: { onSubmit } } = formikBag;
    onSubmit(values, setSubmitting);
  },
})(EmployeeExposureForm);



// WEBPACK FOOTER //
// ./src/features/reports/employee-exposure/EmployeeExposureForm.js